/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import styled from "@mui/styled-engine-sc";
import Dialog from "@mui/material/Dialog";
import React from "react";

const StyledDialog = styled((props) => <Dialog {...props} />)`
  && {
  }
`;

export { StyledDialog };
